module.exports = __webpack_public_path__ + "static/media/resource-detail-img.286239de.jpg";